import store from "@/store"
import http from "./http-service"
import AppLocalStorage from "./app-local-storage"

export default class AuthService {

  static checkUser() {

    let hasUser = false

    AppLocalStorage.check()

    if (store.state.user || AppLocalStorage.get("user"))
      hasUser = true

    return hasUser
  }

  static login(login, password) {

    return http.post("login", { login, password })
      .then((data) => {        

        const { user, authToken, uploadToken } = data

        AppLocalStorage.set("user", user, "setUser")
        AppLocalStorage.set("authToken", authToken, "setAuthToken")
        AppLocalStorage.set("uploadToken", uploadToken, "setUploadToken")

        return data
      })           
  }

  static logout() {    
    return http.post("logout")
  }

  static passwordRecovery(email) {
    return http.post("password-recovery", { email })         
  }

  static checkToken() {
    return http.post("check-token")
  }

  static changePassword(currentPassword, newPassword) {
    return http.post("change-password", { currentPassword, newPassword })
  }
}